/**
 * @file: useIsWeixinAvailable.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { onErrorIgnore } from '@euler/utils';
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import * as WeChat from 'react-native-wechat-lib';

export const useIsWeixinAvailable = () => {
  const [isAvailable, setIsAvailable] = useState(false);
  useEffect(() => {
    if (Platform.OS === 'web') {
      setIsAvailable(true);
      return;
    }
    WeChat.isWXAppInstalled()
      .then(installed => {
        if (installed) {
          setIsAvailable(true);
        }
      })
      .catch(onErrorIgnore);
  }, []);
  return isAvailable;
};
